import { providerColumns } from './provider-columns';

export const createColumnData = (provider) => {
  const values = Object.values(providerColumns);

  const result = {};
  values.forEach((value) => {
    result[value] = provider;
  });

  return result;
};
